module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  require('jquery-timeentry/jquery.timeentry.css'); 
    ; __append("\r\n")
    ;  require('jquery-timeentry/jquery.plugin.min.js'); 
    ; __append("\r\n")
    ;  require('jquery-timeentry/jquery.timeentry.min.js'); 
    ; __append("\r\n")
    ;  var u = require('util/Util.js').default;

var timeValue = specific;
var bHasSeconds = u.isTrue(hasSeconds);
var bShowEmpty = u.isTrue(showEmpty);
var bIs24HourClock = u.isTrue(is24HourClock);

if (bShowEmpty) {
	timeValue = '';
} else {

	timeValue = u.getTime(timeValue, {use24Hour: bIs24HourClock, useSeconds: bHasSeconds})

}

    ; __append("\r\n\r\n<div class=\"propTitle prop-header hide\"><span class=\"prop-label\">Time Input Settings</span></div>\r\n<div class=\"row prop-detail\">\r\n	<div class=\"row\">\r\n		<div class=\"col-md-12 form-group-flex\">\r\n			<input type=\"radio\" name=\"timeValueType\" checked=\"checked\" value=\"Empty\" class=\"form-radio-group\"/> \r\n			<label  class=\"form-group-label\">Empty</label>\r\n		</div>\r\n	</div>\r\n	<div class=\"row\">\r\n		<div class=\"col-md-12 form-group-flex\">\r\n			<input type=\"radio\" name=\"timeValueType\" value=\"Now\" class=\"form-radio-group\"/> \r\n			<label  class=\"form-group-label\">Now</label>\r\n		</div>\r\n	</div>\r\n	<div class=\"row\">\r\n		<div class=\"col-md-4 form-group-flex\" style=\"width: 70px;\">\r\n			<input type=\"radio\" name=\"timeValueType\" value=\"Specific\" class=\"form-radio-group\"/>\r\n			<label  class=\"form-group-label\">Specific</label>\r\n		</div>\r\n		<div class=\"col-md-8\">\r\n			<input type=\"text\" size=\"10\" draggable=\"false\" disabled=\"disabled\" name=\"timeValueSpecific\" id=\"timeValueSpecific\" style=\"width:100px;\" value=\"")
    ; __append(escapeFn(timeValue ))
    ; __append("\"  />\r\n		</div>\r\n	</div>\r\n	<div class=\"row\">\r\n		<div class=\"col-md-12 form-group-flex\">\r\n			<input type=\"checkbox\" name=\"is24HourClock\" id=\"is24HourClock\" class=\"form-radio-group\"/>\r\n			<label class=\"form-group-label\">24 Hour Clock</label>\r\n		</div>\r\n	</div>\r\n	<div class=\"row\">\r\n		<div class=\"col-md-12 form-group-flex\">\r\n			<input type=\"checkbox\" name=\"hasSeconds\" id=\"hasSeconds\" class=\"form-radio-group\"/>\r\n			<label class=\"form-group-label\">Show Seconds</label>\r\n		</div>\r\n	</div>\r\n</div>")
  }
  return __output;

}